import i18n from "@/i18n"
import { email, required, max } from 'vee-validate/dist/rules';
import { extend, validate } from 'vee-validate';
extend('required', {
  ...required,
  message: () => i18n.t('errors.fieldIsRequired')
});
extend("email", {
  ...email,
  message: () => i18n.t('errors.fieldIsRequired')
});
extend("max", {
  ...max,
  message: (field, { length }) => i18n.t(`errors.validation.max`, { max: length })
})

let mlErrors

const mlValidator = required => ({
  params: ["rule"],
  async validate(value, { rule }) {
    if (value == null) return
    mlErrors = {}
    let valid = true
    const languages = Object.keys(value)
    for (let lang of languages) {
      const val = value && value[lang]
      const result = await validate(val, rule)
      if (result.valid == false) {
        mlErrors[lang] = result.errors
        valid = false
      }
    }
    return valid
  },
  message() {
    const stringMessage = mlErrors[Object.keys(mlErrors)[0]][0]
    return {...mlErrors, toString() { return stringMessage }}
  },
  computesRequired: required
})

extend("ml", mlValidator(false))
extend("ml!", mlValidator(true))

const slValidator = required => ({
  params: ["lang", "rule"],
  async validate(value, { lang, rule }) {

    mlErrors = {}
    const val = value && value[lang]
    const result = await validate(val, rule)
    if (result.valid == false) {
      mlErrors[lang] = result.errors
      return false
    }
    return true;
  },
  message() {
    const stringMessage = mlErrors[Object.keys(mlErrors)[0]][0]
    return {...mlErrors, toString() { return stringMessage }}
  },
  computesRequired: required
})

extend("sl", slValidator(false))

extend("sl!", slValidator(true))